var APPEARANCE;
(function (APPEARANCE) {
    APPEARANCE["OUTLINED"] = "outlined";
    APPEARANCE["PRIMARY"] = "primary";
    APPEARANCE["SECONDARY"] = "secondary";
    APPEARANCE["TERTIARY"] = "tertiary";
})(APPEARANCE || (APPEARANCE = {}));
var SHAPE;
(function (SHAPE) {
    SHAPE["DEFAULT"] = "default";
    SHAPE["SQUARE"] = "square";
})(SHAPE || (SHAPE = {}));
var SIZE;
(function (SIZE) {
    SIZE["LG"] = "lg";
    SIZE["MD"] = "md";
    SIZE["SM"] = "sm";
    SIZE["XS"] = "xs";
})(SIZE || (SIZE = {}));
var VARIANT;
(function (VARIANT) {
    VARIANT["DEFAULT"] = "default";
    VARIANT["SUCCESS"] = "success";
    VARIANT["DANGER"] = "danger";
})(VARIANT || (VARIANT = {}));

export { APPEARANCE, SHAPE, SIZE, VARIANT };
